import { EventBusSrv, EventBusExtended } from '@credativ/plutono-data';

export const appEvents: EventBusExtended = new EventBusSrv();

export default appEvents;
